import styled from 'styled-components';

export const Container = styled.div`
  width: 208px;
  flex-shrink: 0;
  margin-left: auto;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    margin-left: 0;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    width: 200px;
    flex-shrink: 0;
    margin-left: auto;
  }
`;

export const Box = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 44px;
  height: var(--ui-control-height, 44px);
  background: rgba(20, 20, 20, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  color: #fff;
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  outline: none;
  transition: all 0.3s ease;
  -webkit-appearance: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.08);
    background: rgba(30, 30, 30, 0.8);
  }

  @media (max-width: 768px) {
    padding: 0 15px 0 36px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    padding: 0 10px 0 28px;
    font-size: 10px;
    height: 32px;
    box-sizing: border-box;
  }
`;

export const Icon = styled.span`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  pointer-events: none;

  @media (max-width: 768px) {
    left: 10px;
    font-size: 14px;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    left: 8px;
    font-size: 12px;
  }
`;
